import { PayloadAction } from '../../../../../store.model';
import { Sort, SortOrder } from '../../grid';
import { ActionType } from '../main.action';
import { MainState } from '../main.state';

import { SortRows } from './sort-rows.action';

export function sortRowsReducer(
    state: MainState,
    action: PayloadAction<ActionType.WP_MAIN__SORT_ROWS, SortRows>,
): MainState {
    try {
        const currentSortState: Sort = state.sortOptions ?? {
            columnId: null,
            order: null,
        };
        let nextSortOrder = SortOrder.ASC;
        if (currentSortState.columnId === action.payload.columnId) {
            nextSortOrder =
                currentSortState.order === SortOrder.ASC
                    ? SortOrder.DESC
                    : SortOrder.ASC;
        }
        const nextSortOptions: Sort = {
            ...currentSortState,
            columnId: action.payload.columnId,
            order: nextSortOrder,
        };

        return {
            ...state,
            sortOptions: nextSortOptions,
        };
    } catch (err) {
        console.log(err);

        return state;
    }
}
